import { useState } from 'react';
import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from '../../common/navigation/SideNavigationMenu';
import Paths from "common/paths/paths";
import { useFlashBarItems } from 'common/UseFlashBarItems/useFlashBarItems';
import { Flashbar, SpaceBetween } from "@amzn/awsui-components-react";
import { useOrderEdit } from './useOrderEdit';
import { SinglePageDetailsContainer } from 'components/OrderDetailsContent/SinglePage/SinglePageDetailsContainer';
import { NonCancelableEventHandler } from "@amzn/awsui-components-react/polaris/internal/events";
import { SplitPanel } from "@amzn/awsui-components-react/polaris";
import { AuditTrailsTable } from "../../components/AuditTrails/AuditTrailsTable";
import { HAM_CONSUMER } from "../../interfaces/constants";
import { Relation } from "@amzn/ito-client";

interface OrderDetailsSingleViewPageProps {
  isExternalView?: boolean
  isItseMode?: boolean
}

const OrderDetailsSingleViewPage = (props: OrderDetailsSingleViewPageProps) => {
  const flashBarItemsHook = useFlashBarItems();
  const { items, actions } = useOrderEdit(flashBarItemsHook.actions, props.isExternalView);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [showSplitPanel, setSplitPanel] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [orderReference, setOrderReference] = useState("");
  const [orderRelations, setOrderRelations] = useState<Relation[]>([])
  const [consumer, setConsumer] = useState(HAM_CONSUMER)

  const breadcrumbs = {
    items:
      [
        { text: Paths.Admin.name, href: Paths.Admin.url },
        { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
        { text: items.orderReference, href: "#" }
      ]
  }

  const onSplitPanelToggle: NonCancelableEventHandler = () => {
      setSplitPanel(false);
  };

  const showAuditsPanel = (orderId: string | undefined, orderReference: string | undefined,
                           orderRelations: Relation[], consumer: string) => {
      if(orderId) {
          setOrderId(orderId);
      }
      if(orderReference) {
          setOrderReference(orderReference);
      }
      setOrderRelations(orderRelations);
      setConsumer(consumer);
      setSplitPanel(true);
  };

  return (
    <AppLayout
      maxContentWidth={2300}
      stickyNotifications
      content={
        <SpaceBetween direction="vertical" size="m">
          <SinglePageDetailsContainer
            useOrderEditItems={items}
            useOrderEditActions={actions}
            useFlashBarItemsActions={flashBarItemsHook.actions}
            showAuditsPanel={showAuditsPanel}
            isItseMode={props.isItseMode}
            isExternalView={props.isExternalView}
          />
        </SpaceBetween>
      }
      contentType="default"
      breadcrumbs={!props.isExternalView && <NavigationBreadcrumbs items={breadcrumbs.items} />}
      navigation={<SideNavigationMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
      navigationHide={props.isExternalView}
      notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems data-testid="notifications-flashbar" />}
      toolsHide={true}
      splitPanelOpen={showSplitPanel}
      onSplitPanelToggle={onSplitPanelToggle}
      splitPanel={
          <SplitPanel
              closeBehavior="hide"
              data-testid="audit-trail-split-panel"
              header={orderReference}
              hidePreferencesButton={true}
          >
              <AuditTrailsTable
                orderId={orderId}
                orderConsumer={consumer}
                orderRelations={orderRelations}
              />
          </SplitPanel>
      }
    />
  );
}

export default OrderDetailsSingleViewPage;
